import React, { useState } from 'react';
import AnniversaryIntro from './AnniversaryIntro';

// Permanent "Celebrating 6th Year" seal shown in the top-right corner of every page.
// Clicking it replays the full-screen anniversary intro.

// 5-point star polygon centred on (cx, cy)
const starPoints = (cx, cy, outer, inner) => Array.from({ length: 10 }, (_, i) => {
  const r = i % 2 === 0 ? outer : inner;
  const a = (Math.PI / 5) * i - Math.PI / 2;
  return `${(cx + r * Math.cos(a)).toFixed(2)},${(cy + r * Math.sin(a)).toFixed(2)}`;
}).join(' ');

// Sparkles around the seal: position (% of wrapper), size (px), animation delay (s)
const SPARKLES = [
  { top: -6, left: 8, size: 14, delay: 0 },
  { top: 12, left: 92, size: 10, delay: 0.5 },
  { top: 78, left: 96, size: 13, delay: 1.1 },
  { top: 96, left: 30, size: 9, delay: 1.6 },
  { top: 55, left: -8, size: 11, delay: 0.8 },
  { top: -10, left: 60, size: 8, delay: 1.9 },
];

const AnniversaryBadge = () => {
  const [replay, setReplay] = useState(false);

  return (
    <>
      <button
        type="button"
        className="anniv-seal"
        onClick={() => setReplay(true)}
        title="Celebrating 6 years of Dani Job Club - thank you!"
        aria-label="Celebrating 6th year of Dani Job Club. Click to replay the celebration."
      >
        <span className="anniv-seal-pulse" />
        <span className="anniv-seal-glow" />
        <span className="anniv-seal-orbit"><i /><i /><i /></span>

        <svg className="anniv-seal-svg" viewBox="0 0 200 200" aria-hidden="true">
          <defs>
            <radialGradient id="annivBase" cx="35%" cy="30%" r="75%">
              <stop offset="0%" stopColor="#3a2f00" />
              <stop offset="55%" stopColor="#120f00" />
              <stop offset="100%" stopColor="#000" />
            </radialGradient>
            <linearGradient id="annivGold" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#fff6c2" />
              <stop offset="35%" stopColor="#FFD600" />
              <stop offset="65%" stopColor="#e0a800" />
              <stop offset="100%" stopColor="#fff1a0" />
            </linearGradient>
            <path id="annivArcTop" d="M 30,100 A 70,70 0 0,1 170,100" />
            <path id="annivArcBottom" d="M 19,100 A 81,81 0 0,0 181,100" />
            <clipPath id="annivClip"><circle cx="100" cy="100" r="96" /></clipPath>
          </defs>

          <circle cx="100" cy="100" r="97" fill="url(#annivBase)" />
          <circle cx="100" cy="100" r="95" fill="none" stroke="url(#annivGold)" strokeWidth="4" />
          <circle cx="100" cy="100" r="88" fill="none" stroke="#FFD600" strokeOpacity="0.45" strokeWidth="1" strokeDasharray="2 4" />
          <circle cx="100" cy="100" r="61" fill="none" stroke="url(#annivGold)" strokeWidth="2" />

          <text className="anniv-seal-arc" fill="url(#annivGold)">
            <textPath href="#annivArcTop" startOffset="50%" textAnchor="middle">CELEBRATING</textPath>
          </text>
          <text className="anniv-seal-arc anniv-seal-arc-sm" fill="#ffffff">
            <textPath href="#annivArcBottom" startOffset="50%" textAnchor="middle">DANI JOB CLUB</textPath>
          </text>

          <polygon className="anniv-seal-star" points={starPoints(22, 100, 8, 3.4)} fill="#FFD600" />
          <polygon className="anniv-seal-star anniv-seal-star-b" points={starPoints(178, 100, 8, 3.4)} fill="#FFD600" />

          <text x="100" y="124" textAnchor="middle" className="anniv-seal-num" fill="url(#annivGold)">
            6<tspan className="anniv-seal-th" dy="-32">TH</tspan>
          </text>
          <text x="100" y="146" textAnchor="middle" className="anniv-seal-year" fill="#ffffff">YEAR</text>

          <g clipPath="url(#annivClip)"><g transform="rotate(20 100 100)">
            <rect className="anniv-seal-shine" x="-60" y="-20" width="40" height="240" fill="#fff" opacity="0.18" />
            </g>
          </g>
        </svg>

        {SPARKLES.map((s, i) => (
          <svg
            key={i}
            className="anniv-sparkle"
            viewBox="0 0 24 24"
            style={{ top: `${s.top}%`, left: `${s.left}%`, width: s.size, height: s.size, animationDelay: `${s.delay}s` }}
            aria-hidden="true"
          >
            <path d="M12 0 C13 8 16 11 24 12 C16 13 13 16 12 24 C11 16 8 13 0 12 C8 11 11 8 12 0 Z" fill="#FFD600" />
          </svg>
        ))}
      </button>

      {replay && <AnniversaryIntro onDone={() => setReplay(false)} />}
    </>
  );
};

export default AnniversaryBadge;
